import { apiUrl } from './config';
import { getPromise } from './utils';

const getUserStockList = (abortSignal, region) =>
  getPromise(
    `${apiUrl}/misc/userStockList`,
    { region },
    undefined,
    abortSignal
  );

export default {
  getUserStockList,
};
